import React, { useState, useEffect } from 'react';

import { Redirect } from 'react-router-dom';
import { dataBkkbn } from '../../components/PouchDB/PouchDBProvider';

function Export() {

    const [dataBkkbnDocs, setDataBkkbnDocs] = useState([]);
    const [reload, setReload] = useState(false)

    const getAllDataBkkbn = async () => {

        try {
            const data = await dataBkkbn.local.allDocs({
                include_docs: true,
            });
            
            const newDocs = [];
            data.rows.forEach(item => {
                if (item.doc.user_name) {
                    newDocs.push(item.doc);
                }
            });

            //setDataBkkbnDocs(newDocs)
            console.log("data newdoc => ", newDocs)

            if (newDocs.length > 0) {
                
                const fileName = "dataBkkbn-local";
                const json = JSON.stringify(newDocs);
                const blob = new Blob([json],{type:'application/json'});
                const href = await URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.download = fileName + ".json";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
    
                setTimeout(() => {
                    setReload(true)
                }, 1000)

            } else {
                var alert = window.confirm("Data Bkkbn Local Tidak Tersedia");

                if (alert) {
                    setReload(true)
                } else {
                    setReload(true)
                }
            }


            // const fileName = "file";
            // const json = JSON.stringify(myData);
            // const blob = new Blob([json],{type:'application/json'});
            // const href = await URL.createObjectURL(blob);

        } catch (error) {
            console.log("err => ",error)
        }
    }

    useEffect(() => {
        
        getAllDataBkkbn();

    }, [])

    if (reload) {
        const redirecTo = '/login';
        return <Redirect to={redirecTo} />
    }


    return (
        <>
        </>
    )

}

export default Export